import _request from './request.js';

export default {
    getItems(){
        return _request.request("api/deposit/items");
    },
    getBalance(currency_id){
        return _request.request("api/deposit/balance",{
            currency_id:currency_id
        },"POST");
    },
    submitDeposit(form){
        return _request.request("api/deposit/deposit",form,"POST");
    },
	getProfit(){
		return _request.request("api/deposit/profit");
	},
	changeAuto(did){
		return _request.request("api/deposit/change",{
			did:did
		},"POST");
	},
	list(param){
		return _request.request("api/deposit/list",param);
	},
	/**
	 * 赎回质押产品
	 * 接口地址: POST https://api.dbgm-hk.com/api/deposit/back
	 * 
	 * @param {Object} form - 赎回参数
	 * @param {Number} form.did - 质押订单ID（必填）
	 * @param {Number} [form.type=0] - 赎回类型（可选，默认0）
	 *   - 0: 立即赎回（扣除1%手续费）
	 *   - 1: 延迟赎回（12小时后，无手续费）
	 * 
	 * @returns {Promise} 接口返回的Promise
	 * 
	 * 请求示例：
	 * 立即赎回: { did: 1, type: 0 } 或 { did: 1 }（type默认为0）
	 * 延迟赎回: { did: 1, type: 1 }
	 */
	redeem(form){
		return _request.request("api/deposit/back",form,"POST");
	}
}